export const CREATE_COST_OPTIMIZATION = `
  mutation createCostOptimization($recommendation: CostOptimizationInput!) {
    createCostOptimizationRecommendation(recommendation: $recommendation) {
      data {
        recommendation_id
        status
      }
      error {
        code
        message
        statusCode
      }
    }
  }
`
